import { Country } from "app/_models/country.model";

export class CalamityModel {
  calId : string ;
  calName : string= null;
  calKind : string= null;
  calCountry : Country= null;
  calLocation : string = null;
  calCreatedDate: Date = new Date();
  calLocalTime : Date = null;
  calSosinternationalCoordinatingAlarmcenter : string = null;
  calPassengerList : string = null;
  calLocalAlarmcenter : string = null;
  calGroupTravel : string = null;
  calTeamTowardsCalamity : string = null;
  calDescription : string = null;
  calStatusNavigation : any = null;
  calFrom : Date = new Date();
  calTill : Date = new Date();
  calTotalDossiers : number = 0;
}